import { createBrowserRouter, type RouteObject } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { ErrorPage } from 'src/components/ErrorPage';
import { PlayerView } from 'src/views/PlayerView';

const playerRoutes: Array<RouteObject> = [
  {
    path: '/player/:eventSlug',
    element: <PlayerView />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/player',
    element: <ErrorPage />,
    errorElement: <ErrorPage />,
  },
];

const router = createBrowserRouter(playerRoutes);

export const PlayerRouter = () => {
  return <RouterProvider router={router} />;
};
